import { createReducer, on } from '@ngrx/store';
import * as StoragesActions from '../actions/storages.actions';

export const storagesFeatureKey = 'storages';

export interface State {
  currentPage: number,
  storages: any,
  storagesPath: any,
  filterType: string,
  filterID: number
  total: number,
  query: string,
  isLoading: boolean,
  sortType: string,
  direction: string,
  storage: any,
  selected: any,
  isMasterChecked: boolean,
  barcodes: any[]

  /**
   * Errors
   */
  duplicateBarcode: boolean
}

export const initialState: State = {
  currentPage: 0,
  storages: null,
  storagesPath: null,
  storage: null,
  filterType: null,
  total: 0,
  filterID: 0,
  query: "",
  isLoading: true,
  sortType: null,
  direction: null,
  selected: [],
  isMasterChecked: false,
  barcodes: null,
  duplicateBarcode: false
};

export const reducer = createReducer(
  initialState,

  on(StoragesActions.loadStorages, state => state),
  on(StoragesActions.loadStoragesSuccess, (state, action) => ({
    ...state,
    storages: [...action.storages],
    total: action.total,
    isLoading: false
  })),
  on(StoragesActions.loadStoragesFailure, (state, action) => state),
  on(StoragesActions.loadStoragesPath, state => state),
  on(StoragesActions.loadStoragesPathSuccess, (state, action) => ({
    ...state,
    storagesPath: [...action.storagesPath],
    isLoading: false
  })),
  on(StoragesActions.loadStoragesPathFailure, (state, action) => state),
  on(StoragesActions.updateStorage, state => state),
  on(StoragesActions.updateStorageSuccess, (state, { storage }) => ({
    ...state,
    storages: state.storages.map(item => {
      if(storage!=null && storage.storageStructureID!=null && item.storageStructureID == storage.storageStructureID){
        return storage;
      }else{
        return item
      }
    }),
    storage: storage,
    isLoading: false
  })),
  on(StoragesActions.loadStorage, state => state),
  on(StoragesActions.loadStorageSuccess, (state, action) => ({
    ...state,
    storage: action.storage,
    isLoading: false
  })),
  on(StoragesActions.loadStorageFailure, (state, action) => state),
  on(StoragesActions.deleteStorage, (state, action) => ({
    ...state,
  })),
  on(StoragesActions.deleteStorageSuccess, (state, action) => ({
    ...state,
    storages: state.storages.filter(storage => storage.storageStructureID != action.storageStructureID),
  })),
  on(StoragesActions.deleteStoragesSuccess, (state, action) => ({
    ...state,
    isMasterChecked: false
  })),
  on(StoragesActions.saveStorage, state => state),
  on(StoragesActions.saveStorageSuccess, (state, action) => ({
    ...state,
    storages: [action.storage, ...state.storages],
    total: state.total +  1
  })),
  on(StoragesActions.saveStorageFailure, (state, action) => state),

  on(StoragesActions.search, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(StoragesActions.searchSuccess, (state, action) => ({
    ...state,
    storages: action.storages,
    total: action.total,
    isLoading: false
  })),
  on(StoragesActions.searchFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(StoragesActions.resetPage, (state, action) => ({ 
    ...state,
    currentPage: 0
  })),
  on(StoragesActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(StoragesActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(StoragesActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID
  })),
  on(StoragesActions.setSelected, (state, action) => ({
    ...state,
    selected: action.selected,
    isMasterChecked: true
  })),
  on(StoragesActions.setDeselected, (state) => ({
    ...state,
    selected: [],
    isMasterChecked: false
  })),
  on(StoragesActions.setSort, (state, action) => ({
    ...state,
    sortType: action.sort,
    direction: action.direction
  })),
  on(StoragesActions.resetStorage, (state, action) => ({
    ...state,
    storage: null
  })),
  on(StoragesActions.resetStorages, (state, action) => ({
    ...state,
    storages: [],
    isLoading: true
  })),
  on(StoragesActions.resetFilter, (state, action) => ({
    ...state,
    filterType: null,
    filterID: null
  })),
  on(StoragesActions.setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading
  })),

);
